import { showHttpError, showSuccess } from '@calendly/alert'
import { parseQuery } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { pushQueryParams } from 'actions/core/navigation'
import { setFormErrors } from 'actions/form'

import { createGroup, listGroups } from '../api'
import { userGroupsParamsSelector } from './selectors'
import { destroyUserGroup } from '../destroy/actions'

export const fetchUserGroups = createAsyncThunk(
  'userGroups/fetch',
  async (_, { rejectWithValue, dispatch, getState }) => {
    const params = userGroupsParamsSelector(getState())
    const [success, response] = await listGroups(params)

    if (!success) {
      dispatch(showHttpError(response))
      return rejectWithValue(null)
    }

    return response
  }
)

export const createUserGroup = (params, options = { onSuccess: () => {} }) => async (dispatch) => {
  const [success, response] = await createGroup(params)

  if (!success) {
    dispatch(setFormErrors(response))
    return
  }

  options.onSuccess(response)
  dispatch(showSuccess(I18n.t('publisher.flash.saved')))
}

const slice = createSlice({
  name: 'userGroups',
  initialState: {
    status: 'initial',
    userGroups: {
      collection: []
    },
    params: {
      filter_term: '',
      sort_field: 'name',
      sort_order: 'asc'
    }
  },
  reducers: {
    setPage: (state, { payload }) => {
      state.params.page = payload
    },
    setFilter: (state, { payload }) => {
      state.params.page = 1
      state.params.filter_term = payload
    },
    toggleSort: (state, { payload: newSortField }) => {
      const { sort_field: previousSortField, sort_order: previousSortOrder } = state.params

      if (previousSortField !== newSortField) {
        state.params.sort_order = 'asc'
      } else {
        state.params.sort_order = previousSortOrder === 'desc' ? 'asc' : 'desc'
      }
      state.params.sort_field = newSortField
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserGroups.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(fetchUserGroups.fulfilled, (state, action) => {
      state.status = 'loaded'
      state.userGroups = action.payload
    })
    builder.addCase(fetchUserGroups.rejected, (state) => {
      state.status = 'failed'
      state.userGroups = { collection: [] }
    })
    builder.addCase(destroyUserGroup.fulfilled, (state, action) => {
      state.userGroups.collection = state.userGroups.collection.filter(({ id }) => id !== action.payload)
    })
  }
})

export const selectPage = (page) => (dispatch) => {
  dispatch(slice.actions.setPage(page))
  dispatch(pushQueryParams({ page }))
}

export const setDefaultPage = () => (dispatch) => {
  const params = parseQuery(window.location.search)
  dispatch(slice.actions.setPage(params.page || 1))
}

export const { reducer, actions: { setFilter, toggleSort } } = slice
